import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button, ControlledField, NexForm, WeeklyScheduleField, ControlledTimezoneSelect } from 'components';
import { SaveIcon } from 'resource';

interface MentorFormProps {
  control: any;
  errors: any;
  handleSubmit: any;
  isSubmitting: boolean;
  submitted: boolean;
  additionalButton?: React.ReactNode;
}

export const MentorForm: React.FC<MentorFormProps> = ({
  control,
  errors,
  handleSubmit,
  isSubmitting,
  submitted,
  additionalButton,
}) => {
  return (
    <NexForm gap={4} handleSubmit={handleSubmit}>
      <Typography variant="h3">導師註冊資料</Typography>
      <Box display="grid" gap={2.5}>

        <ControlledField
          label="顯示名稱 - Your Display Name"
          name="name"
          control={control}
          required
          error={errors.name}
        />

        <ControlledField
          label="您的職稱 - Title"
          name="title"
          control={control}
          required
          error={errors.title}
        />

        <ControlledField
          label="Email"
          name="email"
          control={control}
          required
          error={errors.email}
        />
        <ControlledField
          label="Country"
          name="countryCode"
          control={control}
          required
          error={errors.countryCode}
        />

        <ControlledTimezoneSelect
          label="時區 - Timezone"
          name="timezone"
          control={control}
          required
          error={errors.timezone}
          helperText="請選擇您的時區，這將用於預約時間的顯示"
        />

        <WeeklyScheduleField
          label="Available Time"
          name="availableTime"
          control={control}
          required
          error={errors.availableTime}
        />

        <ControlledField
          label="Booking Link"
          name="bookingLink"
          control={control}
          error={errors.bookingLink}
          placeholder="https://your-booking-link.com"
        />

        <ControlledField
          label="諮詢內容"
          name="tags"
          control={control}
          required
          error={errors.tags}
          placeholder="ex: 職涯規劃, 面試技巧 ..."
          helperText="Please separate by comma"
        />

        <ControlledField
          label="個人簡介 - Profile"
          name="profileBio"
          control={control}
          error={errors.profileBio}
          multiline
          rows={10}
        />

        <Box display="flex" gap={1}>
          <Button
            disabled={isSubmitting || submitted}
            startIcon={<SaveIcon />}
            type="submit"
            color="primary"
            sx={{ width: 'fit-content', height: '40px' }}
          >
            更新導師資料
          </Button>
          {additionalButton && additionalButton}
        </Box>

      </Box>
    </NexForm>
  );
};
